import { Popconfirm, Tooltip } from 'antd'
import { Download, Eye, Trash2 } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

interface DocumentActionsProps {
  onView?: () => void
  onDownload?: () => void
  onDelete?: () => void
  deleteConfirmTitle?: string
  deleteConfirmDescription?: string
  canView?: boolean
  canDownload?: boolean
  canDelete?: boolean
  className?: string
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
`

const ActionButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.forecast.defaultText};
  padding: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: ${({ theme }) => theme.forecast.background1};
    color: ${({ theme }) => theme.forecast.primary};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  onView,
  onDownload,
  onDelete,
  deleteConfirmTitle = 'Delete document',
  deleteConfirmDescription = 'Are you sure you want to delete this document?',
  canView = true,
  canDownload = true,
  canDelete = true,
  className,
}) => {
  return (
    <Container className={className}>
      {onView && (
        <Tooltip title='View document'>
          <ActionButton onClick={onView} disabled={!canView}>
            <Eye size={16} />
          </ActionButton>
        </Tooltip>
      )}

      {onDownload && (
        <Tooltip title='Download document'>
          <ActionButton onClick={onDownload} disabled={!canDownload}>
            <Download size={16} />
          </ActionButton>
        </Tooltip>
      )}

      {onDelete && (
        <Popconfirm
          title={deleteConfirmTitle}
          description={deleteConfirmDescription}
          onConfirm={onDelete}
          okText='Delete'
          cancelText='Cancel'
          okButtonProps={{ danger: true }}>
          <ActionButton disabled={!canDelete}>
            <Trash2 size={16} />
          </ActionButton>
        </Popconfirm>
      )}
    </Container>
  )
}
